import { Card, Tooltip } from 'antd'
import React from 'react'
import { formatNumberWithCommas } from '../../utilities/CommonHelper'

const DashboardCard = (props:any) => {

    const convertCuurencyintoBillionMillionThousandFormat = (value:any) => {
        if(value>=1000000000){
          return `${(value/1000000000).toFixed(2)}B`;
        }
        else if(value>=1000000){
          return `${(value/1000000).toFixed(2)}M`;
        }
        else if(value>=1000){
          return `${(value/1000).toFixed(2)}K`;
        }
        else{
          return value
        }
      }
  return (
    <Card 
    bodyStyle={{padding:'0'}}
                style={{  
                    textAlign:'center',
                    padding:'0',
                    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
                 }}
                >
                    <div
                     style={{
                    }}
                     >
                        <div style={{
                        alignContent:'center',
                        marginTop:'10px',
                        
                        }}><span style={{
                            fontSize:'1em', 
                            fontWeight:'bold',
                            font : 'normal normal bold 15px / 19px Nunito Sans'
                            }}>{props.title }</span></div>
                    
                    <div 
                        style={{
                            padding:'10px'
                        }}
                        >
                            {props.labelType === "currency"? (<span style={{
                                fontWeight:'bold',
                                fontSize:'2em',
                                }}
                                onClick={() => {navigator.clipboard.writeText(`$${formatNumberWithCommas(props.value)}`)}}
                                >
                                    <Tooltip title={`$${formatNumberWithCommas(props.value)}` } >
                                        ${convertCuurencyintoBillionMillionThousandFormat(props.value)}
                                    </Tooltip>
                                </span>):
                                <span style={{
                                  fontWeight:'bold',
                                  fontSize:'2em',
                                  }}
                                  >
                                  {formatNumberWithCommas(props.value)}
                                  </span>
                                }
                            </div>
                        </div>
                  </Card>
  )
}

export default DashboardCard